import React from "react";
import { Outlet } from "react-router-dom";
import GlobalNav from "@/components/GlobalNav";
import TopBar from "@/components/TopBar";
import AtlasStatusBar from "@/components/AtlasStatusBar";
import AtlasOrbWidget from "@/components/AtlasOrbWidget";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import PlatformNoticeAcknowledgment from "@/components/PlatformNoticeAcknowledgment";
import { useAuth } from "@/lib/AuthContext";

export default function AppLayout() {
    const { user, company, logout } = useAuth();

    const handleLogout = () => {
        logout();
        window.location.assign("/");
    };

    return (
        <div
            className="h-screen flex overflow-hidden"
            style={{ background: "transparent" }}
        >
            <GlobalNav />
            <div className="flex-1 flex flex-col min-w-0 relative">
                <ImpersonationBanner />
                <TopBar user={user} company={company} onLogout={handleLogout} />
                <div className="flex-1 min-h-0 overflow-hidden relative">
                    <Outlet />
                </div>
                <AtlasStatusBar />
            </div>
            <AtlasOrbWidget />
            <PlatformNoticeAcknowledgment />
        </div>
    );
}
